import React from "react";
import { Bars } from "svg-loaders-react";

function Loader(props) {
  return (
    <Bars
      width="240"
      height="100"
      fill="#ddd"
      className="block m-auto mt-16 mb-16"
    />
  );
}

export default Loader;
